module.exports = __webpack_public_path__ + "js/0-legacy.adf81e23.worker.js"